import React, { CSSProperties, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { AddAnimalToPen, ProgressBar } from "../.."
import { colors, fonts, } from "../../../Styles"

import { TestData as FeedCurveData } from '../../../Assets/TestData/feedCurvesData';
import { TestData as PenData} from '../../../Assets/TestData/lf_Data';
import { TestData as AnimalData } from '../../../Assets/TestData/animalData'

interface PenAdd_Props {
  penId: number
  hasHoverEffekt?: boolean
}
/**
 * PEN_ADD
 * @param penId Unique identifier for each pen.
 * @param hasHoverEffekt Boolean that, if true, adds a hover effect to the pen.
 * @param onClick Dynamic onClick eventhandler.
 * @returns a pen where onMouseEnter adds a hovereffect on empty pens.
 */
export default function PEN_ADD({ penId, hasHoverEffekt }: PenAdd_Props) {
  const {t} = useTranslation()
  const [isHovered, setIsHovered] = useState(false);
  const [showAddAnimalToPenModal, setAddAnimalToPenModal] = useState(false) // Add Animal Modal

  // Find the pen and related data
  const pen = PenData.find(item => item.penId === penId)

  // Find the animal and related data
  const animal = AnimalData.find(item => item.animalId === pen?.animalId);

    // #region | Data handling
  // Handle feedCurve data and parse an empty string if label is undefined
  const feedCurve = FeedCurveData.find(e => e.id === animal?.feedPlan);
  const feedCurveName = feedCurve?.name ?? "";

  // Handle PenData and feeding status
  // const penData = PenData.find(pen => pen.penId === animal.pen);
  const feedCorrection = 
  animal ? 
    (animal.feedCorrection === 0 || animal.feedCorrection === undefined
      ? "0%" 
      : animal.feedCorrection+"%") 
  : "0%";
  const feeding = pen?.feeding ? t("settingsPages.locationFeederSettings.on") : t("settingsPages.locationFeederSettings.off");
  const feedingStyle: CSSProperties = {
    color: pen?.feeding ? colors.systemGreen : colors.systemRed
  };

  // Handle progress bar data
  const progressBarTotal = animal?.totalFood;
  const progressBarProgressed = animal?.remainingToday;

  // Create ProgressBar component
  const progressBar = (
    <ProgressBar 
      total={progressBarTotal} 
      progressed={progressBarProgressed}
    />
  );

  const milestoneDayNo = animal?.milestoneDay
  ? Math.floor((new Date().getTime() - animal.milestoneDay.getTime()) / (1000 * 60 * 60 * 24))
  : "No Data";

  // #endregion

  // #region | Content
  // Advanced content to parse in the div
  const advancedContent =
    <div style={{width: "591px", padding: "0 50px 0px 10px"}}>
      {animal? 
        <div style={{ display: "grid", gridTemplateColumns: "35px 45px 45px 90px 25px 90px 45px 131px 45px", textAlign: "start", alignItems: "center", gap: "5px" }}>
          <span></span>
          <span style={{filter: "opacity(0.5)", cursor: "default"}}>{pen?.penId}</span>
          <span style={{filter: "opacity(0.5)", cursor: "default"}}>{animal.animalId}</span>
          <span style={{filter: "opacity(0.5)", cursor: "default"}}>{animal.milestoneId}</span>
          <span style={{filter: "opacity(0.5)", cursor: "default"}}>{milestoneDayNo}</span>
          <span style={{filter: "opacity(0.5)", cursor: "default", paddingLeft: "5px"}}>{feedCurveName}</span>
          <span style={{filter: "opacity(0.5)", cursor: "default", paddingLeft: "5px"}}>{feedCorrection}</span>
          <span style={{filter: "opacity(0.5)", cursor: "default"}}> {progressBar} </span>
          <span style={{filter: "opacity(0.5)", cursor: "default", paddingLeft: "5px", ...feedingStyle,}}>{feeding}</span>
        </div>
      : 
        <div style={{ display: "grid", gridTemplateColumns: "35px 45px 45px 426px", textAlign: "start", alignItems: "center", gap: "5px" }}>
          <span></span>
          <span style={{cursor: "pointer"}}>{pen?.penId}</span>
          <span style={{cursor: "pointer"}}>{t("locationFeeder.penPopup.empty")}</span>
        </div>
      }
    </div>
  // #endregion
    
  // Open Add Animal Modal on pen click
  const handlePenClick = () => {
    if (!animal) {
      setAddAnimalToPenModal(true);
    }
  };

  // Apply hover effect only if hasHoverEffekt is true
  const handleMouseEnter = () => {
    if (hasHoverEffekt && !animal) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (hasHoverEffekt && !animal) {
      setIsHovered(false);
    }
  };

  return (
    <>
      <div 
        onClick={handlePenClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ 
          width: "651px",
          height: "35px",
          cursor: hasHoverEffekt && !animal? "pointer" : "", 
      }}>
        <div style={{
          width: "100%",
          height: "100%",
          textAlign: 'center',
          alignContent: "center",
          backgroundColor: colors.greyLightSecondary,
          filter: isHovered ? 'opacity(0.5)' : 'opacity(1)',
          transition: 'filter 0.3s',
          color: colors.greyDarkPrimary,
          ...fonts.paragraph,
          ...fonts.fontSize4,
        }}>
          {advancedContent}
        </div>
      </div>
      {/* Add Animal Modal */}
      <AddAnimalToPen isModalOpen={showAddAnimalToPenModal} activePen={pen?.penId ?? 0} goBack={() => setAddAnimalToPenModal(false)} />
    </>
  );
}